export default "__VITE_ASSET__CBzYwxi7__"